import { Routes } from '@angular/router';

import { SearchComponent } from './pages/searches/search.component';
import { RequestComponent } from './pages/requests/request.component';
import { TermsComponent } from './footer/terms.component';
import { ContactComponent } from './footer/contact.component';
import { TankmixDetailComponent} from './pages/searches/tankmix-detail.component';
import { SearchSeedTreatmentComponent } from './pages/searches/search-seed-treatment.component';
import { RequestSeedTreatmentComponent } from './pages/requests/request-seed-treatment.component';
import { PrivacyComponent } from './components/privacy.component';
import { PageNotFoundComponent } from './components/page-not-found.component';
import { UnauthorizedComponent } from './components/unauthorized.component';
import { CallbackComponent } from './components/callback.component';
import { ForbiddenComponent } from './components/forbidden.component';
import { AutoLoginComponent } from './components/auto-login.component';
import { HelenaSearchComponent } from './helena/pages/searches/helena-search.component';
import { HelenaRequestComponent } from './helena/pages/requests/helena-request.component';
import { HelenaTankmixDetailComponent } from './helena/pages/searches/helena-tankmix-detail.component';
import { HelenaPrivacyComponent } from './helena/helena-privacy.component';
import { HelenaSearchSeedTreatmentComponent} from './helena/pages/searches/helena-search-seed-treatment.component';
import { HelenaRequestSeedTreatmentComponent} from './helena/pages/requests/helena-request-seed-treatment.component';
import { RequestSubmittedComponent } from './pages/requests/request-submitted.component';
import { ArticleComponent } from './pages/article.component';
import { MobileNavigationComponent } from './navigation/mobile-navigation.component';
import { SearchHistoryComponent } from './pages/searches/search-history.component';
import { HelenaArticleComponent } from './helena/pages/helena-article.component';

let appRoutes: Routes = [
  { path: '', component: SearchComponent },
  { path: 'search-history/:id', component: SearchComponent },
  { path: 'search-seed-treatment', component: SearchSeedTreatmentComponent },
  { path: 'search-seed-treatment/:id', component: SearchSeedTreatmentComponent },
  { path: 'request', component: RequestComponent },
  { path: 'request-seed-treatment', component: RequestSeedTreatmentComponent },
  { path: 'request-submitted', component: RequestSubmittedComponent },
  { path: 'terms', component: TermsComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'testResult/:tankmixId/:languageCode', component: TankmixDetailComponent },
  { path: 'autologin', component: AutoLoginComponent },
  { path: 'Forbidden', component: ForbiddenComponent },
  { path: 'Unauthorized', component: UnauthorizedComponent },
  { path: 'callback', component: CallbackComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'helena', component: HelenaSearchComponent },
  { path: 'helena/search-history/:id', component: HelenaSearchComponent },
  { path: 'helena/request', component: HelenaRequestComponent },
  { path: 'helena/helena-search-seed-treatment', component: HelenaSearchSeedTreatmentComponent },
  { path: 'helena/helena-search-seed-treatment/:id', component: HelenaSearchSeedTreatmentComponent },
  { path: 'helena/helena-request-seed-treatment', component: HelenaRequestSeedTreatmentComponent },

  { path: 'helena/testResult/:tankmixId/:languageCode', component: HelenaTankmixDetailComponent },
  { path: 'search-history', component: SearchHistoryComponent},
  { path: 'helena/search-history', component: SearchHistoryComponent},

  { path: 'helena/privacy', component: HelenaPrivacyComponent },
  { path: 'helena/advice/:articleId', component: HelenaArticleComponent },
  { path: 'advice/:articleId', component: ArticleComponent },
  { path: 'navigation', component: MobileNavigationComponent },
  { path: '**', component: PageNotFoundComponent },


];
export const myRoutes = appRoutes;


